import { render, staticRenderFns } from "./edit_fees.vue?vue&type=template&id=10a0b302"
import script from "./edit_fees.vue?vue&type=script&lang=js"
export * from "./edit_fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports